export default __webpack_public_path__ + "static/media/logo.63a78ed4.jpg";